@if (isComponentVisible()) {
<div class="outer-container" [class.editor-mode]="customComponent.editorMode">
  <div
    #dropZone
    class="gridster-drop-zone"
    [attr.data-container-uuid]="customComponent.uuid"
    (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  ></div>
  <!-- Responsive Mode -->
  @if (isResponsive) {
  <div class="responsive-container">
    @for (item of customComponent?.childComponents; track item; let i = $index)
    {
    <div
      class="child-component responsive-item"
      [attr.data-component-type]="'child'"
      [ngStyle]="getCustomStyles(item)"
      [class.editor-mode]="customComponent.editorMode"
      [class]="
        item.settings && item.settings['customClasses']
          ? item.settings['customClasses'].value
          : null
      "
      [draggable]="customComponent.editorMode"
      (dragstart)="onChildDragStart($event, item)"
      (dragend)="onChildDragEnd($event)"
    >
      @if (customComponent.editorMode) {
      <div class="drag-handle">
        <div class="button-container">
          <div class="arrow-controls">
            <button
              class="arrow-btn"
              (click)="moveItem(i, 'up')"
              [disabled]="i === 0"
            >
              ↑
            </button>
            <button
              class="arrow-btn"
              (click)="moveItem(i, 'down')"
              [disabled]="
                i === (customComponent.childComponents?.length || 0) - 1
              "
            >
              ↓
            </button>
          </div>
          <div class="item-controls">
            <button
              id="edit_button"
              (click)="
                $event.stopPropagation();
                editComponentFromGridster(item.uuid!, null)
              "
            >
              E
            </button>
            <button
              id="copy_button"
              (click)="
                $event.stopPropagation(); copyComponentFromGridster(item)
              "
            >
              C
            </button>
            <button
              id="delete_button"
              (click)="
                $event.stopPropagation();
                removeComponentFromGridster(item, null)
              "
            >
              D
            </button>
          </div>
        </div>
      </div>
      } @if (isChildComponentVisible(item)) {
      <app-dynamic-component
        [customComponent]="item"
        [editorMode]="customComponent.editorMode"
        [attr.ng-reflect-custom-component-uuid]="item.uuid"
      >
        @if (item.name === 'ComponentContainerComponent') {
        <div
          class="gridster-drop-zone nested"
          [attr.data-container-uuid]="item.uuid"
          (dragenter)="onDragEnter($event)"
          (dragleave)="onDragLeave($event)"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        ></div>
        }
      </app-dynamic-component>
      }
    </div>
    }
  </div>
  }
  <!-- Original Grid/Gridster Mode -->
  @if (!isResponsive) { @if (customComponent.editorMode) {
  <div class="component-container">
    <gridster #gridster [options]="gridsterOptions">
      @for (item of customComponent?.childComponents; track item) {
      <gridster-item [item]="item">
        <div
          class="child-component grid-item"
          [attr.data-component-type]="'child'"
          draggable="true"
          (dragstart)="onChildDragStart($event, item)"
          (dragend)="onChildDragEnd($event)"
        >
          <div class="drag-handle">
            <div class="button-container">
              <button
                id="edit_button"
                (click)="
                  $event.stopPropagation();
                  editComponentFromGridster(item.uuid!, null)
                "
              >
                E
              </button>
              <button
                id="copy_button"
                (click)="
                  $event.stopPropagation(); copyComponentFromGridster(item)
                "
              >
                C
              </button>
              <button
                id="delete_button"
                (click)="
                  $event.stopPropagation();
                  removeComponentFromGridster(item, null)
                "
              >
                D
              </button>
            </div>
          </div>
          @if (isChildComponentVisible(item)) {
          <app-dynamic-component
            [customComponent]="item"
            [editorMode]="customComponent.editorMode"
            [attr.ng-reflect-custom-component-uuid]="item.uuid"
          >
          </app-dynamic-component>
          }
        </div>
      </gridster-item>
      }
    </gridster>
  </div>
  }
  <!-- Display Mode -->
  @if (!customComponent.editorMode) {
  <div class="grid-container">
    @for (item of customComponent?.childComponents; track item) {
    <div
      class="child-component grid-item"
      [attr.data-component-type]="'child'"
      [ngStyle]="{
        'grid-column': (item?.x || 0) + 1 + ' / span ' + (item?.cols || 1),
        'grid-row': (item?.y || 0) + 1 + ' / span ' + (item?.rows || 1)
      }"
      draggable="true"
      (dragstart)="onChildDragStart($event, item)"
      (dragend)="onChildDragEnd($event)"
    >
      @if (isChildComponentVisible(item)) {
      <app-dynamic-component
        [customComponent]="item"
        [editorMode]="customComponent.editorMode"
        [attr.ng-reflect-custom-component-uuid]="item.uuid"
      >
      </app-dynamic-component>
      }
    </div>
    }
  </div>
  } }
</div>
}
